import { Routes, Route } from "react-router-dom";
import { Layout } from "@/components/common/Layout";
import { LoginPage } from "@/pages/login/LoginPage";
import { HomePage } from "@/pages/home/HomePage";
import { RolesPage } from "@/pages/roles";
import { CreateRolePage } from "@/pages/roles/create";
import { EditRolePage } from "@/pages/roles/update";
import { UsersPage } from "@/pages/users/UsersPage";
import { AppRoutes } from "@/constants/routes";
import { ContactPage } from "@/pages/contact/ContactPage";
import { RoleAssignationPage } from "@/pages/role-asignation/RoleAssignationPage";
import { UserRoleAssignCreationPage } from "@/pages/role-asignation/add-edit/UserRoleAssignCreationPage";
import { UserRoleAssignUpdatePage } from "@/pages/role-asignation/add-edit/UserRoleAssignUpdatePage";
import { RolesProvider } from "@/providers/RolesProvider";
import { LightMode } from "@/components/ui/color-mode";
import { AccountsPage } from "@/pages/accounts/AccountsPage";
import { PersonsPage } from "@/pages/persons/PersonsPage";
import { PersonDetailPage } from "@/pages/persons/detail/PersonDetailPage";
import { AccountDetailPage } from "@/pages/accounts/detail/AccountDetailPage";
import { CBUPage } from "@/pages/cbu/CbuPage";
import { CashRequestPage } from "@/pages/requests/cash/CashRequestsPage";
import { CashRequestDetailPage } from "@/pages/requests/cash/detail/CashRequestDetailPage";
import { CashRequestCreationPage } from "@/pages/requests/cash/detail/CashRequestCreationPage";
import { PersonCreationPage } from "@/pages/persons/create/PersonCreationPage";
import { PersonAssociateAccountPage } from "@/pages/persons/detail/PersonAssociateAccountPage";
import { PersonUpdatePage } from "@/pages/persons/update/PersonUpdatePage";
import { CheckRequestPage } from "@/pages/requests/check/CheckRequestsPage";
import { CheckRequestCreationPage } from "@/pages/requests/check/detail/CheckRequestCreationPage";
import { CheckRequestDetailPage } from "@/pages/requests/check/detail/CheckRequestDetailPage";
import { TransferRequestsPage } from "@/pages/requests/transfer/TransferRequestsPage";
import { TransferRequestDetailPage } from "@/pages/requests/transfer/detail/TransferRequestDetailPage";
import { PriceBoardPage } from "@/pages/config/price-board/PriceBoardPage";
import { PriceBoardCreateUpdatePage } from "@/pages/config/price-board/create-update/PriceBoardCreateUpdatePage";
import { RequestPoliciesPage } from "@/pages/config/request-policies/RequestPoliciesPage";
import { RequestPolicyCreationPage } from "@/pages/config/request-policies/create-update/RequestPolicyCreationPage";
import { RequestPolicyUpdatePage } from "@/pages/config/request-policies/create-update/RequestPolicyUpdatePage";
import { MotivesPage } from "@/pages/config/motives/MotivesPage";
import { MotiveCreationPage } from "@/pages/config/motives/create/MotiveCreationPage";
import { MotiveUpdatePage } from "@/pages/config/motives/update/MotiveUpdatePage";
import { ScheduledTransferPage } from "@/pages/requests/scheduled-transfer/ScheduledTransferPage";
import { ScheduledTransferRequestDetailPage } from "@/pages/requests/scheduled-transfer/detail/ScheduledTransferDetailPage";
import { NotFoundPage } from "@/components/not-found/NotFoundPage";
import { RelationFieldsPage } from "@/pages/config/relation-fields/RelationFieldsPage";
import { AddHobbiePage } from "@/pages/config/relation-fields/hobbies/AddHobbiePage";
import { EditHobbiePage } from "@/pages/config/relation-fields/hobbies/EditHobbiePage";
import { AddProfessionPage } from "@/pages/config/relation-fields/professions/AddProfessionPage";
import { EditProfessionPage } from "@/pages/config/relation-fields/professions/EditProfessionPage";
import { FinancialMovementsDescPage } from "@/pages/config/financial-movements-desc/FinancialMovementsDescPage";
import { FinancialMovementsDescCreationPage } from "@/pages/config/financial-movements-desc/detail/FinancialMovementsDescCreationPage";
import { FinancialMovementsDescUpdatePage } from "@/pages/config/financial-movements-desc/detail/FinancialMovementsDescUpdatePage";
import { SellOrderPage } from "@/pages/grain-requests/sell-orders/SellOrderPage";
import { SellOrderCreationPage } from "@/pages/grain-requests/sell-orders/create/SellOrderCreationPage";
import { SellOrderDetailPage } from "@/pages/grain-requests/sell-orders/detail/SellOrderDetailPage";
import { NoPermission } from "@/components/no-permission/NoPermission";
import { CounterDeliveryPage } from "@/pages/grain-requests/counter-delivery/CounterDeliveryPage";
import { CounterDeliveryCreationPage } from "@/pages/grain-requests/counter-delivery/create/CounterDeliveryCreationPage";
import { CounterDeliveryDetailPage } from "@/pages/grain-requests/counter-delivery/detail/CounterDeliveryDetailPage";
import { FutureContractsPage } from "@/pages/grain-requests/future-contract/FutureContractsPage";
import { FutureContractCreationPage } from "@/pages/grain-requests/future-contract/create/FutureContractCreationPage";
import { FutureContractDetailPage } from "@/pages/grain-requests/future-contract/detail/FutureContractDetailPage";
import { SlotRequestsPage } from "@/pages/grain-requests/slot-requests/SlotRequestsPage";
import { SlotRequestDetailPage } from "@/pages/grain-requests/slot-requests/detail/SlotRequestDetailPage";
import { FertSlotRequestsPage } from "@/pages/supplies-requests/fertilizer/FertSlotRequests";
import { FertSlotRequestDetailPage } from "@/pages/supplies-requests/fertilizer/detail/FertSlotRequestDetailPage";
import { FertSlotRequestOrderCreationPage } from "@/pages/supplies-requests/fertilizer/order-creation/FertSlotRequestOrderCreationPage";
import { FertSlotRequestOrderEditPage } from "@/pages/supplies-requests/fertilizer/order-edit/FertSlotRequestOrderEditPage";
import { BackupChecksPage } from "@/pages/requests/backup-checks/BackupChecksPage";
import { BackupCheckDetail } from "@/pages/requests/backup-checks/detail/BackupCheckDetail";
import { MaintenancePage } from "@/pages/config/maintenance/MaintenancePage";
import { ProductsPage } from "@/pages/config/products/ProductsPage";
import { ProductCreationPage } from "@/pages/config/products/create/ProductCreationPage";
import { ProductEditPage } from "@/pages/config/products/edit/ProductEditPage";

export const AppRouter = () => {
  return (
    <Routes>
      <Route
        element={
          <RolesProvider>
            <LightMode>
              <Layout />
            </LightMode>
          </RolesProvider>
        }
      >
        <Route path={AppRoutes.HOME} element={<HomePage />} />
        <Route path={AppRoutes.ROLES} element={<RolesPage />} />
        <Route path={AppRoutes.CREATE_ROLE} element={<CreateRolePage />} />
        <Route path={AppRoutes.UPDATE_ROLE} element={<EditRolePage />} />
        <Route path={AppRoutes.USERS} element={<UsersPage />} />
        <Route path={AppRoutes.CONTACT} element={<ContactPage />} />
        <Route path={AppRoutes.ACCOUNTS} element={<AccountsPage />} />
        <Route
          path={AppRoutes.ACCOUNTS_DETAIL}
          element={<AccountDetailPage />}
        />
        <Route path={AppRoutes.PERSONS} element={<PersonsPage />} />
        <Route path={AppRoutes.PERSON_DETAIL} element={<PersonDetailPage />} />
        <Route
          path={AppRoutes.PERSON_ASSOCIATE_ACCOUNT}
          element={<PersonAssociateAccountPage />}
        />
        <Route
          path={AppRoutes.PERSON_CREATE}
          element={<PersonCreationPage />}
        />
        <Route path={AppRoutes.PERSON_UPDATE} element={<PersonUpdatePage />} />
        <Route path={AppRoutes.CBU} element={<CBUPage />} />
        <Route path={"/onboarding"} element={<>Onboarding</>} />
        {/* Solicitudes de efectivo */}
        <Route path={AppRoutes.CASH_REQUESTS} element={<CashRequestPage />} />
        <Route
          path={AppRoutes.CASH_REQUEST_DETAIL}
          element={<CashRequestDetailPage />}
        />
        <Route
          path={AppRoutes.CASH_REQUEST_CREATION}
          element={<CashRequestCreationPage />}
        />
        {/* Solicitudes de Cheque */}
        <Route path={AppRoutes.CHECK_REQUESTS} element={<CheckRequestPage />} />
        <Route
          path={AppRoutes.CHECK_REQUEST_CREATION}
          element={<CheckRequestCreationPage />}
        />
        <Route
          path={AppRoutes.CHECK_REQUEST_DETAIL}
          element={<CheckRequestDetailPage />}
        />
        {/* Solicitudes de Transferencia */}
        <Route
          path={AppRoutes.TRANSFER_REQUESTS}
          element={<TransferRequestsPage />}
        />
        <Route
          path={AppRoutes.TRANSFER_REQUEST_DETAIL}
          element={<TransferRequestDetailPage />}
        />
        {/* Transferencias programadas */}
        <Route
          path={AppRoutes.SCHEDULED_TRANSFER_REQUESTS}
          element={<ScheduledTransferPage />}
        />
        <Route
          path={AppRoutes.SCHEDULED_TRANSFER_DETAIL}
          element={<ScheduledTransferRequestDetailPage />}
        />
        {/* Asignación de roles */}
        <Route path={AppRoutes.USER_ROLES} element={<RoleAssignationPage />} />
        <Route
          path={AppRoutes.USER_ROLE_CREATION}
          element={<UserRoleAssignCreationPage />}
        />
        <Route
          path={AppRoutes.USER_ROLE_EDIT}
          element={<UserRoleAssignUpdatePage />}
        />
        {/* Configuración */}
        <Route path={AppRoutes.PRICE_BOARD} element={<PriceBoardPage />} />
        <Route
          path={AppRoutes.PRICE_BOARD_ADD}
          element={<PriceBoardCreateUpdatePage />}
        />
        <Route
          path={AppRoutes.REQUEST_POLICIES}
          element={<RequestPoliciesPage />}
        />
        <Route
          path={AppRoutes.REQUEST_POLICIES_ADD}
          element={<RequestPolicyCreationPage />}
        />
        <Route
          path={AppRoutes.REQUEST_POLICIES_EDIT}
          element={<RequestPolicyUpdatePage />}
        />
        <Route path={AppRoutes.MOTIVES} element={<MotivesPage />} />
        <Route path={AppRoutes.MOTIVE_ADD} element={<MotiveCreationPage />} />
        <Route path={AppRoutes.MOTIVE_EDIT} element={<MotiveUpdatePage />} />
        <Route
          path={AppRoutes.RELATION_FIELDS}
          element={<RelationFieldsPage />}
        />
        <Route path={AppRoutes.HOBBIE_ADD} element={<AddHobbiePage />} />
        <Route path={AppRoutes.HOBBIE_EDIT} element={<EditHobbiePage />} />
        <Route
          path={AppRoutes.PROFESSION_ADD}
          element={<AddProfessionPage />}
        />
        <Route
          path={AppRoutes.PROFESSION_EDIT}
          element={<EditProfessionPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC}
          element={<FinancialMovementsDescPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC_ADD}
          element={<FinancialMovementsDescCreationPage />}
        />
        <Route
          path={AppRoutes.FINANCIAL_MOVEMENTS_DESC_EDIT}
          element={<FinancialMovementsDescUpdatePage />}
        />
        <Route path={AppRoutes.SELL_ORDERS} element={<SellOrderPage />} />
        <Route
          path={AppRoutes.SELL_ORDER_DETAIL}
          element={<SellOrderDetailPage />}
        />
        <Route
          path={AppRoutes.SELL_ORDER_CREATION}
          element={<SellOrderCreationPage />}
        />

        <Route
          path={AppRoutes.GRAIN_DELIVERY_PAYMENTS}
          element={<CounterDeliveryPage />}
        />
        <Route path={AppRoutes.GRAIN_DELIVERY_DETAIL} element={<CounterDeliveryDetailPage />} />
        <Route path={AppRoutes.GRAIN_DELIVERY_CREATION} element={<CounterDeliveryCreationPage />} />

        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS} element={<FutureContractsPage />} />
        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS_DETAIL} element={<FutureContractDetailPage />} /> 
        <Route path={AppRoutes.GRAIN_FUTURE_CONTRACTS_CREATION} element={<FutureContractCreationPage />} />

        {/* CUPOS */}

        <Route path={AppRoutes.SLOT_REQUESTS} element={<SlotRequestsPage />} />
        <Route path={AppRoutes.SLOT_REQUEST_DETAIL} element={<SlotRequestDetailPage />} /> 
        <Route path={AppRoutes.SLOT_REQUEST_CREATION} element={<></>} />

        {/* SOLICITUDES INSUMOS */}
        <Route path={AppRoutes.FERT_SLOTS_REQ} element={<FertSlotRequestsPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_DETAIL} element={<FertSlotRequestDetailPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_ORDER_CREATION} element={<FertSlotRequestOrderCreationPage />} />
        <Route path={AppRoutes.FERT_SLOTS_REQ_ORDER_DETAIL} element={<FertSlotRequestOrderEditPage />} />

        {/* CHEQUES RESPALDO */}
        <Route path={AppRoutes.BACKUP_CHECKS} element={<BackupChecksPage />} />
        <Route path={AppRoutes.BACKUP_CHECKS_DETAIL} element={<BackupCheckDetail />} />

        {/* MANTENIMIENTO MOBILE */}
        <Route path={AppRoutes.APP_MAINTENANCE} element={<MaintenancePage />} />

        {/* MAESTRO DE PRODUCTOS */}
        <Route path={AppRoutes.PRODUCTS} element={<ProductsPage />} />
        <Route path={AppRoutes.PRODUCTS_CREATION} element={<ProductCreationPage />} />
        <Route path={AppRoutes.PRODUCTS_EDIT} element={<ProductEditPage />} />

        {/* NOT FOUND */}
        <Route path={"*"} element={<NotFoundPage />} />
        <Route path={AppRoutes.NO_PERMISSION} element={<NoPermission />} />
      </Route>
      <Route
        path={AppRoutes.LOGIN}
        element={
          <LightMode>
            <LoginPage />
          </LightMode>
        }
      />
    </Routes>
  );
};
